import React from 'react'
import acuadori_home from "../assets/acuadori_home.png";
import UiIntro from './uiIntro';
import UiSettings from './uiSettings'
import { Redirect } from 'react-router-dom';
import { Button, Container, ButtonGroup, Row, Col, Image, } from 'react-bootstrap';

class UiHome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nextRoute: props.nextRoute,
            redirect: false
        }
    }

    redirect = (thbPath) => {
        let nextRoute = this.props.nextRoute;
        this.setState({ redirect: true, nextRoute: nextRoute })
    }

    render() {
        let { thingsboardRoutes, chirpstackRoutes } = this.props.links;
        let thbRoutes = Object.keys(thingsboardRoutes);
        let chsRoutes = Object.keys(chirpstackRoutes);
        return (
            <Container>
                {!!this.state.redirect && <Redirect to={this.state.nextRoute} />}
                <Container>
                    <Row className="m-1 p-1 justify-content-center" >
                        <Image fluid src={acuadori_home} alt={<UiIntro {...UiSettings.Intro} />} />
                    </Row>
                </Container>
                <Container>
                    <Row>
                        <Col xl xs={'auto'}>
                            <Row>
                                <Col>
                                    <Row>
                                        <h3 className="text-primary">Thingsboard</h3>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <ButtonGroup>
                                                <Col>
                                                    {thbRoutes.map(key => {
                                                        let route = thingsboardRoutes[key];
                                                        return (
                                                            <Row className='m-1'>
                                                                <Button  key={key}
                                                                    className="border-dark"
                                                                    onClick={(event) => {
                                                                        window.open(route);
                                                                        this.redirect(key)
                                                                    }}
                                                                >{key}
                                                                </Button>
                                                            </Row>
                                                        )
                                                    })}
                                                </Col>
                                            </ButtonGroup>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xl xs={'auto'}>
                            <Row>
                                <Col>
                                    <Row>
                                        <h3 className="text-secondary">LoraWan</h3>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <ButtonGroup>
                                                <Col>
                                                    {chsRoutes.map(key => {
                                                        let route = chirpstackRoutes[key];
                                                        return (
                                                            <Row className='m-1'>
                                                                <Button key={key}
                                                                    variant="secondary"
                                                                    className="border-dark"
                                                                    onClick={(event) => {
                                                                        window.open(route);
                                                                        this.redirect(key)
                                                                    }}
                                                                > {key}</Button>
                                                            </Row>
                                                        )
                                                    })}
                                                </Col>
                                            </ButtonGroup>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Container>
        );
    }
}


export default UiHome;